import {Alert, Divider, Spin} from "@ui";
import {useCallback, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {HeadingCarousel} from "@/components/heading-carousel/heading-carousel.component";
import {ConfEnv} from "../../../../../config/config";
import {useGetLiveGames} from "../../../../../hooks/games/useGetLiveGames.hook";
import {useBetbyWidgetManager} from "../../../../../hooks/useBetbyWidgetManager";
import useGetTokenBetby from "../../../../../hooks/useGetTokenBetby";
import useBetbyStore from "../../../../../store/Betby/useBetbyStore.store";
import {useAuthStore} from "../../../../../store/useAuth.store";
import styles from "./LiveGames.module.css";

const LiveGames = () => {
  useGetLiveGames();
  // const [selectedSport, setSelectedSport] = useState("Soccer");
  const {t} = useTranslation();

  const lang = "es";

  // Extract currency from URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const currency = urlParams.get("currency") || "VES"; // Default to VES if no currency specified
  const authStatus = useAuthStore(state => state.authStatus);
  const tokenBetby = useBetbyStore(state => state.tokenBetby);

  // Use the hook instead of calling service directly
  const {isLoading: isTokenLoading} = useGetTokenBetby(lang, currency, authStatus === "authenticated");

  // Stable callback handler to prevent unnecessary re-renders
  const handleBannerClick = useCallback(args => {
    window.location.assign(`/sports?page=${args.url}`);
  }, []);

  // Create widget configuration using the same pattern as other Betby widgets
  const widgetConfig = useMemo(() => {
    if (!tokenBetby || authStatus !== "authenticated") {
      return null;
    }

    return {
      token: tokenBetby,
      brand_id: ConfEnv.API_BETBY.BRAND_ID,
      lang: lang,
      themeName: ConfEnv.API_BETBY.THEME,
      widgetName: "promo", // This matches the original widget name
      widgetParams: {
        placeholder: "operator_page1",
        onBannerClick: handleBannerClick,
        onError: _error => {},
      },
    };
  }, [tokenBetby, authStatus, lang, handleBannerClick]);

  // Use the Betby widget manager - same as other widget components
  const {
    containerRef,
    isLoading: isWidgetLoading,
    error,
    retryInitialization,
    setError,
  } = useBetbyWidgetManager(widgetConfig);

  const [hasContent, setHasContent] = useState(false);
  const [mountNode, setMountNode] = useState(null);

  const setWidgetContainerRef = useCallback(
    node => {
      containerRef(node);
      setMountNode(node);
    },
    [containerRef]
  );

  useEffect(() => {
    if (!mountNode) return;

    const observer = new MutationObserver(() => {
      setHasContent(mountNode.children.length > 0);
    });
    observer.observe(mountNode, {childList: true, subtree: true});

    return () => observer.disconnect();
  }, [mountNode]);

  // const handleSportChange = (sport) => {
  //   setSelectedSport(sport);
  // };

  const isLoading = isTokenLoading || isWidgetLoading;

  return (
    <div
      id="liveGames"
      className={styles.liveGamesRow}
      style={{display: !isLoading && !error && !hasContent ? "none" : undefined}}
    >
      <HeadingCarousel
        title={t("homeDisplayLiveGames")}
        subtitle={t("homeDisplayLiveGamesSubtitle")}
        icon="🏆"
        viewAllLink="/sports"
      />
      {/* <div className={styles.liveGamesContainer}>
        <h2 className={styles.liveGamesTitle}>{t("homeDisplayLiveGames")}</h2>
      </div>
      <div className={styles.liveGamesIconsContainer}>
        <ul className={styles.liveGamesIconsList}>
          <button
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => handleSportChange("Soccer")}
          >
            <li
              className={`${styles.liveGamesIcons} ${
                selectedSport === "Soccer" ? styles.icon_selected : ""
              }`}
            >
              <FaFutbol />
              <h3 className={styles.liveGamesIconsName}>
                {t("homeDisplayFootball")}
              </h3>
            </li>
          </button>
          <button
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => handleSportChange("Tennis")}
          >
            <li
              className={`${styles.liveGamesIcons} ${
                selectedSport === "Tennis" ? styles.icon_selected : ""
              }`}
            >
              <GiTennisBall style={{fontSize: "2.3rem"}} />
              <h3 className={styles.liveGamesIconsName}>
                {t("homeDisplayTennis")}
              </h3>
            </li>
          </button>
          <button
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => handleSportChange("Volleyball")}
          >
            <li
              className={`${styles.liveGamesIcons} ${
                selectedSport === "Volleyball" ? styles.icon_selected : ""
              }`}
            >
              <FaVolleyballBall />
              <h3 className={styles.liveGamesIconsName}>
                {t("homeDisplayVolleyball")}
              </h3>
            </li>
          </button>
          <button
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => handleSportChange("Basketball")}
          >
            <li
              className={`${styles.liveGamesIcons} ${
                selectedSport === "Basketball" ? styles.icon_selected : ""
              }`}
            >
              <FaBasketballBall />
              <h3 className={styles.liveGamesIconsName}>
                {t("homeDisplayBasketball")}
              </h3>
            </li>
          </button>
        </ul>

        <div>
          <h3 style={{fontWeight: "bold", fontSize: "1.2rem"}}>
            {selectedSport}
          </h3>
        </div>
      </div> */}

      {isLoading && (
        <Spin
          size="large"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px 0",
          }}
        />
      )}

      {error && (
        <Alert
          message={t("error")}
          description={error}
          type="error"
          showIcon
          style={{marginBottom: "16px"}}
          closable
          onClose={() => setError(null)}
          action={
            <button
              type="button"
              onClick={retryInitialization}
              style={{
                padding: "8px 16px",
                backgroundcolor: "var(--status-error)",
                color: "var(--text-primary)",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              {t("retry", "Retry")}
            </button>
          }
        />
      )}

      <div
        ref={setWidgetContainerRef}
        style={{
          width: "100%",
        }}
      />

      <Divider style={{marginTop: "20px"}} />
    </div>
  );
};

export default LiveGames;
